import FilterBox from './filter_box';
import FilterPills from './filter_pills';

export default FilterBox;

export { FilterPills };
